var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "new-store-welcome-container" },
    [
      _c("h2", { staticClass: "title is-size-4" }, [_vm._v("What's new?")]),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c("BaseButton", {
        attrs: {
          classNames: ["button--modifier", "input-field-button"],
          title: "Login/Sign-up",
          type: "fill"
        },
        on: { click: _vm.showLogin }
      }),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "tp-link",
          attrs: { href: _vm.getFAQLink, target: "_blank" }
        },
        [_vm._v("Frequently Asked Questions")]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "new-features-message" }, [
      _c("ul", [
        _c("li", { staticClass: "feature is-size-5" }, [
          _vm._v(
            "Securely save your payment information for a fast and convenient checkout!"
          )
        ]),
        _vm._v(" "),
        _c("li", { staticClass: "feature is-size-5" }, [
          _vm._v("Earn loyalty rewards when you order online or in-store!")
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-430ab689", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-430ab689","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/landing/NewStoreWelcome.vue
// module id = null
// module chunks = 